import { ofType, combineEpics } from "redux-observable";
import { switchMap, mergeMap, catchError } from "rxjs/operators";
import { Observable, of } from "rxjs";
import "rxjs-compat";
import FlightSearchResources from "@ane/exp-data/lib/resources/FlightSearchResources";
import FlightSearchActions from "../actions/FlightSearchActions.js";
import FlightSearchContants from "../models/FlightSearchConstants.js";
import FlightSearchUtils from "../utils/FlightSearchUtils.js";
import SearchLogPerformanceActions from "../../../Common/logging/SearchLogPerformanceActions.js";
const flightSearchEpic = (action$) => {
  return action$.pipe(
    ofType(FlightSearchContants.FETCH_FLIGHT_RESULTS),
    switchMap((value) => {
      return Observable.concat(
        of(SearchLogPerformanceActions.flightSearchStart()),
        Observable.fromPromise(FlightSearchResources.searchFlights(value.payload)).pipe(
          mergeMap((result) => {
            return of(
              FlightSearchActions.getFlightsComplete(FlightSearchUtils.parseDto(result), false),
              SearchLogPerformanceActions.flightSearchMainFunctionality(),
              SearchLogPerformanceActions.flightSearchFullLoad()
            );
          }),
          catchError((error) => of(FlightSearchActions.getFlightsComplete([], true)))
        )
      );
    })
  );
};
const flightSearchEpics = combineEpics(flightSearchEpic);
export {
  flightSearchEpic,
  flightSearchEpics
};
//# sourceMappingURL=FlightSearchEpic.js.map
